export default __webpack_public_path__ + "static/media/deactivate-flight.d1ebff99.svg";